<script>
/* Vue native methods */
import { computed, inject, onBeforeMount, onMounted, reactive, ref, watch, watchEffect } from 'vue';

/* Vue router */
import { useRouter } from 'vue-router';

/* Axios imports */
import axios_native from 'axios';
import axios from '../config/axios';

/* Data Strings */
import tooltipData from '../strings/tooltip-data';
import tooltipDataWl from '../strings/tooltip-data-wl';

/* Components */
import InputChoice from './InputChoice';
import FormComponent from './FormComponent.vue';
import DateTimePickerComponent from './DateTimePickerComponent.vue';
import Multiselect from '@vueform/multiselect';
import Toggle from '@vueform/toggle';

/* Helper functions */
import ApiHelper from '../helpers/apiHelper';

/* Pinia */
import { useAppDataStore } from '../stores/appDataStore';

export default {
  components: {
    InputChoice,
    FormComponent,
    DateTimePickerComponent,
    Multiselect,
    Toggle
  },
  props: {},
  setup() {
    const appDataStore = useAppDataStore();
    const appData = computed(() => appDataStore.appData);
    const firstFormComponent = ref(null);
    const installationFormComponent = ref(null);
    const dateTimePickerComponent = ref(null);
    const router = useRouter();

    // Fetch GET params from URL
    const queryObject = Object.fromEntries(new URLSearchParams(window.location.search));

    const app_theme_brand = ref(BRAND_THEME);

    const localStorageSteps = ref(`johanniter-steps-careconsulting2_${BRAND_THEME}`);

    let stepHistory = reactive([1]); // Array of steps for full history on how user has navigated trough steps using the thermometer
    let windowWidth = ref(window.innerWidth);

    const stepTransitionDuration = ref(100);

    let currentStep = ref(1);
    let currentCompletedStep = ref(0);
    const previousStep = ref(1);
    const steps = reactive([{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }]);

    const tooltipContent = ref(tooltipData);
    const tooltipContentWl = ref(tooltipDataWl);

    let formErrorMessage = ref('');
    let validationErrors = ref([]);

    let acListFocused = ref(false);

    let agree = ref(false);


    /********************************************************************************************************
     /**************************************** COMPUTED ******************************************************
     /********************************************************************************************************/

    const isMobile = computed(() => {
      return windowWidth.value <= 768;
    });

    /********************************************************************************************************
     /**************************************** METHODS *******************************************************
     /********************************************************************************************************/

    const handleFormSubmit = async () => {
      let version = 'version=default';
      let land = '&landesverband=' + encodeURIComponent(appData.value.region);
      let postUrl = `${__API_URL__}/care_consulting/submit?${version}${land}`;

      let Verfügbarkeitsquelle = '';
      let Datum = '';
      let meetingTimeFrom = '';
      let meetingTimeTo = '';
      let meetingType = '';
      let meetingReserved = 'FALSCH';
      let preferedMeetingDate = 'FALSCH';
      let Wunschzeitfenster = '';

      if (appData.value.contact.termin_select) {
        meetingReserved = 'WAHR';
        Datum = appData.value.s4.value.substring(0, 10);

        meetingTimeFrom = appData.value.s4.meeting_time.substring(0, 5);
        meetingTimeTo = appData.value.s4.meeting_time.substring(8, 13);

        meetingType = 'physisch';
        Verfügbarkeitsquelle = 'Standardliste';
        preferedMeetingDate = appData.value.contact.meeting_times_input;

        if (appData.value.contact.meeting_times_input == 'WAHR') {
          meetingReserved = 'FALSCH';
          Wunschzeitfenster = appData.value.s4.value + ', ' + appData.value.s4.meeting_time;
        }
      }

      let installationAddress = appData.value.installation_address_checkbox ? 'FALSCH' : 'WAHR';
      let zipOfContact = appData.value.contact.zipOfContact?.value?.postcode || appData.value.contact.zipOfContact.postcode;

      let installationAddressZipOfContact = '';

      if (appData.value.contact.installation_address_zipOfContact) {
        installationAddressZipOfContact = appData.value.contact.installation_address_zipOfContact?.value?.postcode || appData.value.contact.installation_address_zipOfContact.postcode;
      }

      let installationAddressPhone = appData.value.contact.installation_address_phone || '';

      let mailBodyData = {
        Kontaktaufnahme: 'sofort',
        Servicecenter: appData.value.region,
        PLZ_Ort: appData.value.contact.zip + ', ' + appData.value.contact.city,
        Hausnotruftyp: appData.value.s4.value,
        Nutzer: appData.value.s1.value,
        Pflegegrad: appData.value.s3.value,
        Krankenkasse: appData.value.s3.krankenkasse.name,
        Gesundheitsfuersorge: appData.value.s3.value_2,
        kampagne: appData.value.usersource,
        Preis: appData.value.price,
        Wunschzeitfenster: Wunschzeitfenster,
        Daten_Wunschtermin: preferedMeetingDate,
        Verfügbarkeitsquelle: Verfügbarkeitsquelle,
        Termin_gebucht: meetingReserved,
        Uhrzeit_von: meetingTimeFrom,
        Uhrzeit_bis: meetingTimeTo,
        Art_des_Termins: meetingType,
        Datum: Datum,
        Anrede: appData.value.contact.anrede,
        Name: appData.value.contact.lastname,
        Quelle: BRAND_THEME,
        Vorname: appData.value.contact.firstname,
        Adresse: appData.value.contact.street.value + ' ' + appData.value.contact.house_number,
        PLZ_Ansprechpartner: appData.value.contact.zipOfContact.value.postcode,
        Stadt: appData.value.contact.stadt,
        Vorwahl: appData.value.contact.phone_prefix,
        Telefon: appData.value.contact.phone,
        Email: appData.value.contact.email,
        Anrede_Kunde: appData.value.contact.installation_address_anrede,
        Vorname_Kunde: appData.value.contact.installation_address_firstname,
        Nachname_Kunde: appData.value.contact.installation_address_lastname,
        Adresse_Kunde: appData.value.contact.installation_address_street.value + ' ' + appData.value.contact.installation_address_house_number,
        PLZ_Kunde: installationAddressZipOfContact,
        Telefon_Kunde: installationAddressPhone,
        Email_Kunde: appData.value.contact.installation_address_email,
        Daten_Kunde: installationAddress,
        Datenschutz: agree.value,
        meeting_times_api: appData.value.contact.meeting_times_api,
        meeting_times_api_ts: appData.value.contact.meeting_times_api_ts
      };

      if (appData.value.contact.termin_select) {
        let intervals = [];
        intervals.push({
          'date': appData.value.s4.value,
          'startTime': appData.value.s4.meeting_time.substring(0, 5) + ':00',
          'endTime': appData.value.s4.meeting_time.substring(8, 5) + ':00',
          'capacity': appData.value.s4.capacity
        });

        let intervalsJSON = JSON.stringify(intervals);
        let config = {
          params: {
            zipcode: appData.value.contact.zip,
            interval: intervalsJSON
          }
        };

        clearDatepicker();

        // In production environment post meeting time data
        if (INST !== 'dev') {
          const apiHelper = new ApiHelper('https://www.johanniterhausnotruf.de/mt.php', 'POST', config);
          const intervalResponse = await apiHelper.fetchData();

          if (intervalResponse.data.intervalls && intervalResponse.data.intervalls.length === 0) {
            localStorage.clear();
            const redirectBase = BRAND_THEME === 'default' ? '/' : `/${BRAND_THEME}`;
            window.location.replace(redirectBase);
            return;
          }
        }
      }

      const apiHelper = new ApiHelper(postUrl, 'POST', mailBodyData);
      const response = await apiHelper.fetchData();

      let redirect_url = response.data?.redirect_url;

      if (redirect_url) {
        // Clear stored data
        localStorage.clear();
        window.top.location.href = redirect_url;
      }

    };

    // Appends the currently active step to the URL as param ?schritt
    const appendStepToUrl = () => {
      const query = { schritt: currentStep.value };
      router.push({ query });
    };

    // Save the current step progress to local storage
    const saveProgress = (currentStep, currentCompletedStep) => {
      localStorage.setItem(
        localStorageSteps.value,
        JSON.stringify({
          currentStep: currentStep.value,
          currentCompletedStep: currentCompletedStep.value
        })
      );
    };

    const handleValidationErrors = (errors) => {
      validationErrors = errors;
    };
    // Clear date & time picker values
    const clearDatepicker = () => {
      appData.value.s4.value = '';
      appData.value.contact.termin_select = false;
      dateTimePickerComponent.value.closePopup();
    };

    // Handle zipcode API request each time user updates zipcode field value
    const handleACChange = async (data) => {
      if (data.length < 2) {
        return;
      }

      try {
        const apiUrl = `${__API_URL__}/care_consulting/services?zip=${data}`;

        const apiHelper = new ApiHelper(apiUrl, 'GET', '');
        const response = await apiHelper.fetchData();

        if (response.status !== 200 && response.status !== 204) {
          console.error('Fetching zipcodes failed: ', response.status);
          return;
        }

        // Map the response in to the format that is needed for autocomplete component
        appData.value.s2.options = response.data.data.map((item) => ({
          value: {
            id: item.id,
            zip: item.zip,
            city: item.city,
            region: item.landesverband,
            meeting_times: item.meeting_times,
            public_holidays: item.public_holidays,
            base: item.base
          }
        }));
      } catch (error) {
        console.error('Error handling AC select:', error);
      }

      // appData.value.s2.value = data;
      appData.value.s2.zipCodeErrorVisible = false;
    };
    // Handle zipcode selection from the dropdown
    const handleACSelect = async (data) => {
      appData.value.s2.zipCodeErrorVisible = false;
      appData.value.contact.zip = appData.value.s2?.value?.zip || appData.value.s2.value?.value.zip;
      appData.value.contact.city = appData.value.s2?.value?.city || appData.value.s2.value?.value.city;
      appData.value.contact.servicesID = appData.value.s2?.value?.id || appData.value.s2.value?.value.id;
      appData.value.region = appData.value.s2?.value?.region || appData.value.s2.value?.value.region;
      appData.value.contact.meeting_times = appData.value.s2?.value?.meeting_times || appData.value.s2.value?.value.meeting_times;
      appData.value.contact.public_holidays = appData.value.s2?.value?.public_holidays || appData.value.s2.value?.value.public_holidays;

      const base = appData.value.s2?.value?.base || appData.value.s2.value?.value.base;
      appData.value.s2.value = data

      appData.value.contact.meeting_times_api = '';
      appData.value.s3.value = '';
      appData.value.s4.value = '';
      appData.value.contact.termin_select = false;

      if (base) {
        appData.value.priceApi = true;
        appData.value.price = data.base;
      } else {
        appData.value.priceApi = false;
      }

      acListFocused.value = false;

      // Handle meeting time intervals & exceptions for step 6 datepicker
      if (appData.value.contact.meeting_times) {
        const intervalsJSON = getIntervalExceptions();

        let config = {
          params: {
            zipcode: appData.value.contact.zip,
            interval: intervalsJSON
          }
        };

        const apiHelper = new ApiHelper('https://www.johanniterhausnotruf.de/mt.php', 'POST', config);
        const intervalExceptionsResponse = await apiHelper.fetchData();

        if (intervalExceptionsResponse.status !== 200 && intervalExceptionsResponse.status !== 204) {
          console.error('Fetching interval exceptions failed: ', intervalExceptionsResponse.status);
          return;
        }

        appData.value.contact.meeting_times_api = intervalExceptionsResponse.data['intervalls'];
        appData.value.queryId = intervalExceptionsResponse.data['queryId'];

        //Get year, month, and day part from the date
        let date = new Date();
        let year = date.toLocaleString('default', { year: 'numeric' });
        let month = date.toLocaleString('default', { month: '2-digit' });
        let day = date.toLocaleString('default', { day: '2-digit' });

        appData.value.contact.meeting_times_api_ts = year + '-' + month + '-' + day;
      }

      if (INST == 'dev') {
        appData.value.contact.meeting_times_api = [
          { 'date': '30.11.2025', 'startTime': '14:00', 'endTime': '16:00', 'options': 1, 'available': 1 },
          { 'date': '1.12.2025', 'startTime': '14:00', 'endTime': '16:00', 'options': 1, 'available': 1 },
          { 'date': '2.12.2025', 'startTime': '14:00', 'endTime': '16:00', 'options': 1, 'available': 1 },
          { 'date': '13.06.2025', 'startTime': '14:00', 'endTime': '16:00', 'options': 1, 'available': 1 },
          { 'date': '14.06.2025', 'startTime': '14:00', 'endTime': '16:00', 'options': 1, 'available': 1 },
          { 'date': '15.06.2025', 'startTime': '14:00', 'endTime': '16:00', 'options': 1, 'available': 1 },
          { 'date': '19.06.2025', 'startTime': '14:00', 'endTime': '16:00', 'options': 1, 'available': 1 }
        ];
        appData.value.queryId = '33111333-777555';
      }

    };
    // Handle what happens when user clicks or taps out of the zipcode options dropdown
    const handleACClose = () => {
      appData.value.s2.zipCodeErrorVisible = false;

      // If there is only one option left then autoselect it
      if (appData.value.s2.options?.length == 1) {
        appData.value.s2.value = appData.value.s2.options[0];
        handleACSelect(appData.value.s2.options[0]);
      }
      // If there are two options left show error
      if (appData.value.s2.options?.length == 2) {
        appData.value.s2.zipCodeErrorVisible = true;
        appData.value.s2.value = '';
      }
    };
    const handleACClear = () => {
      appData.value.s2.value = '';
      appData.value.s3.value = '';
      appData.value.s3.value_2 = '';
      appData.value.s3.krankenkasse.name = '';

      appData.value.contact.meeting_times = '';
      appData.value.contact.meeting_times_api = '';
      appData.value.contact.meeting_times_api_ts = '';
      appData.value.queryId = '';
    };

    const handleIframeHeight = (scrollStatus = false) => {
      /* On step switch send new height */
      return setTimeout(function() {
        const htmlHeight = document.getElementsByTagName('html')[0].offsetHeight;
        parent.postMessage({ height: htmlHeight + 50, scroll: scrollStatus }, '*');
      }, stepTransitionDuration + 300);
    };
    // Gets the last step that the user has completed
    const getLastCompletedStep = () => {
      let latestCompletedStep = 0;

      // Get the latest completed step
      steps.forEach(step => {
        // Check if step data has been set
        if (appData.value[`s${step.id}`] && appData.value[`s${step.id}`].value) {
          latestCompletedStep = step.id;
        }
      });

      return latestCompletedStep;
    };
    // Handles navigating trough steps by clicking the thermometer
    const handleThermometerProgress = (stepId) => {
      if (currentStep.value == stepId) {
        return;
      }

      let latestCompletedStep = getLastCompletedStep();

      // If user clicks on a step that is not yet completed then navigate the user to the latest completed step
      if (stepId > latestCompletedStep + 1) {
        // If user is submitting the step 6 form
        if (stepId === 5 && latestCompletedStep === 3) {
          return handleStepProgress(stepId, currentStep.value);
        }

        handleStepProgress(latestCompletedStep + 1, currentStep.value);
        formErrorMessage.value =
          currentStep.value === 2 ? 'Bitte geben Sie die Postleitzahl ein und wählen Sie Ihren Ort aus der Liste aus.' : 'Bitte wählen Sie eine Option aus';
        return;
      }

      return handleStepProgress(stepId, currentStep.value);
    };

    const handleStepProgress = async (stepId, previousStep = null) => {
      if (appData.value.contact.region && !appData.value.contact.region.includes('Landesverband ')) {
        localStorage.clear();
        const redirectBase = BRAND_THEME === 'default' ? '/' : `/${BRAND_THEME}`;
        window.location.replace(redirectBase);
        return;
      }

      /* On step 6 send form on next button click */
      if (stepId === 5) {
        // Validate all form fields
        firstFormComponent.value.validateAllFields();

        // Do not proceed if validation failed
        if (validationErrors.length > 0) {
          // Scroll to the form
          firstFormComponent.value.$el.scrollIntoView({ behavior: 'smooth' });
          return;
        }

        // If the installation address is enabled
        if (!appData.value.installation_address_checkbox && installationFormComponent.value) {
          // Validate installation address form fields
          installationFormComponent.value.validateAllFields('installation_address_');
        }

        handleIframeHeight(true);

        // User has selected that they want to book a meeting time but have not selected a meeting time
        if (appData.value.contact.termin_select && (!appData.value.s4.value || !appData.value.s4.meeting_time)) {
          formErrorMessage.value = 'Bitte füllen Sie alle Felder des Formulars aus.';
          return;
        }

        // Do not proceed if validation failed
        if (validationErrors.length > 0) {
          // Scroll to the form
          firstFormComponent.value.$el.scrollIntoView({ behavior: 'smooth' });
          return;
        }

        // If the user has somehow selected a date from the past
        if (appData.value.s4.value && appData.value.contact.termin_select) {
          let dateString = appData.value.s4.value; // Oct 23
          let dateParts = dateString.split('.');
          let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], 0);
          let mydate = new Date(dateObject);
          let today = new Date();

          if (today > mydate) {
            localStorage.clear();
            const redirectBase = BRAND_THEME === 'default' ? '/' : `/${BRAND_THEME}`;
            window.location.replace(redirectBase);
            return;
          }
        }

        if (agree.value === false) {
          formErrorMessage.value = 'Bitte füllen Sie alle Felder des Formulars aus.';
          return;
        }

        formErrorMessage.value = '';

        // Submit the form data
        await handleFormSubmit();
        return;
      }

      if (stepId === 4) {
        if (appData.value.s3.value_2 === '' || appData.value.s3.krankenkasse.name === '') {
          formErrorMessage.value = 'Bitte wählen Sie eine Option aus';
          return;
        } else {
          formErrorMessage.value = '';
        }
      }

      if (
        (!appData.value[`s${currentStep.value}`] || appData.value[`s${currentStep.value}`].value == '') && stepId > currentStep.value
      ) {
        formErrorMessage.value =
          currentStep.value === 2 ? 'Bitte geben Sie die Postleitzahl ein und wählen Sie Ihren Ort aus der Liste aus.' : 'Bitte wählen Sie eine Option aus';

        if (currentStep.value === 2) {
          acListFocused.value = true;
        }

        return;
      }

      formErrorMessage.value = '';

      // Last completed step logic
      if (currentStep.value <= stepId && currentCompletedStep.value <= currentStep.value) {
        // Save recently completed step
        currentCompletedStep.value = currentStep.value;
      }

      // Go to the selected step
      currentStep.value = stepId;

      // Add the step id to step history array
      if (stepHistory[stepHistory.length - 1] !== stepId) {
        stepHistory.push(stepId);
      }

      // Save progress to local storage
      saveProgress(currentStep, currentCompletedStep);

      // Send current height to iframe
      handleIframeHeight(true);

      // Append current step to URL
      appendStepToUrl();

      if (isMobile.value) {
        document.querySelector('.progress').scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    };

    // Handle meeting time intervals & exceptions for step 6 datepicker
    const getIntervalExceptions = () => {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      d.setHours(0, 0, 0, 0);

      let dayTypeDBtoJavascript = {
        0: 1,
        1: 2,
        2: 3,
        3: 4,
        4: 5,
        5: 6,
        6: 0
      };

      let intervals = [];
      let exceptions = [];
      let intervalExceptions = [];

      for (let y = 0; y <= 62; y++) {
        for (let i = 0; i < appData.value.contact.meeting_times.length; i++) {
          if (dayTypeDBtoJavascript[appData.value.contact.meeting_times[i].day] === d.getDay()) {
            intervals.push({
              'date': String(d.getDate()).padStart(2, '0') + '.' + (String(d.getMonth() + 1).padStart(2, '0')) + '.' + d.getFullYear(),
              'startTime': appData.value.contact.meeting_times[i].open_from,
              'endTime': appData.value.contact.meeting_times[i].open_to,
              'capacity': appData.value.contact.meeting_times[i].capacity
            });
          }
        }
        d.setDate(d.getDate() + 1);
      }

      // Extract exceptions from meeting times
      for (let i = 0; i < appData.value.contact.meeting_times.length; i++) {
        appData.value.contact.meeting_times[i].exceptions?.forEach(exception => {
          // Create separate array for exception dates
          exceptions.push([
            exception.from_date,
            exception.to_date,
            appData.value.contact.meeting_times[i].open_from,
            appData.value.contact.meeting_times[i].open_to,
            exception.capacity
          ]);
        });
      }

      // Calculate the difference between start date and end date & add dates that are in between them to exceptions
      exceptions.forEach(dateRange => {
        const [startDate, endDate, openFrom, openTo, capacity] = dateRange;
        const currentDate = new Date(startDate);

        // Parse end date to include it in the loop
        const parsedEndDate = new Date(endDate);
        parsedEndDate.setDate(parsedEndDate.getDate() + 1);

        while (currentDate < parsedEndDate) {
          // Format the date as DD.MM.YYYY
          const day = String(currentDate.getUTCDate()).padStart(2, '0');
          const month = String(currentDate.getUTCMonth() + 1).padStart(2, '0');
          const year = currentDate.getUTCFullYear();

          const formattedDate = `${day}.${month}.${year}`;
          let data = { 'date': formattedDate, 'startTime': openFrom, 'endTime': openTo, 'capacity': capacity };

          intervalExceptions.push(data);
          currentDate.setDate(currentDate.getDate() + 1);
        }
      });

      // Merge intervals and exceptions, do not create duplicates
      intervals.forEach(interval => {
        const exists = intervalExceptions.some(exception =>
          exception.date === interval.date &&
          exception.startTime === interval.startTime &&
          exception.endTime === interval.endTime
        );

        // Only push to intervalExceptions if the interval does not already exist
        if (!exists) {
          intervalExceptions.push(interval);
        }
      });

      return JSON.stringify(intervalExceptions);
    };

    /***********************************************************************************************************
     /**************************************** onBeforeMount ***************************************************
     /**********************************************************************************************************/

    onBeforeMount(() => {
      if ('clearcache' in queryObject && queryObject.clearcache === 'true') {
        localStorage.clear();
      }

      // Getting the current step and current completed step from localstorage
      if (localStorage.getItem(localStorageSteps.value) !== null) {
        const parsedLocalStorageData = JSON.parse(localStorage.getItem(localStorageSteps.value));
        currentStep.value = parsedLocalStorageData.currentStep || 1;
        currentCompletedStep.value = parsedLocalStorageData.currentCompletedStep || 1;
      }

    });


    /***********************************************************************************************************
     /**************************************** onMounted *******************************************************
     /**********************************************************************************************************/

    onMounted(() => {
      // Attach event listener to window resize event
      window.addEventListener('resize', () => {
        windowWidth.value = window.innerWidth;
      });

      handleIframeHeight();
    });

    /***********************************************************************************************************
     /**************************************** WATCHERS *********************************************************
     /**********************************************************************************************************/

    watch(
      () => appData.value.installation_address_checkbox,
      (newValue) => {
        if (newValue === true) {
          appData.value.contact.installation_address_anrede = '';
          appData.value.contact.installation_address_email = '';
          appData.value.contact.installation_address_zipOfContact = '';
          appData.value.contact.installation_address_firstname = '';
          appData.value.contact.installation_address_lastname = '';
          appData.value.contact.installation_address_house_number = '';
          appData.value.contact.installation_address_phone = '';
          appData.value.contact.installation_address_phone_prefix = '';
          appData.value.contact.installation_address_stadt = '';
          appData.value.contact.installation_address_street = '';
        }
        handleIframeHeight();
      }
    );

    return {
      acListFocused,
      agree,
      firstFormComponent,
      installationFormComponent,
      dateTimePickerComponent,
      stepHistory,
      windowWidth,
      queryObject,
      stepTransitionDuration,
      app_theme_brand,
      localStorageSteps,
      currentStep,
      currentCompletedStep,
      previousStep,
      steps,
      tooltipContent,
      tooltipContentWl,
      appData,
      formErrorMessage,
      validationErrors,
      isMobile,
      handleFormSubmit,
      appendStepToUrl,
      saveProgress,
      handleValidationErrors,
      clearDatepicker,
      handleACChange,
      handleACSelect,
      handleACClose,
      handleACClear,
      handleIframeHeight,
      getLastCompletedStep,
      handleStepProgress,
      handleThermometerProgress
    };
  }
};
</script>

<template>
  <div id="root" :class="app_theme_brand" class="root">
    <div class="root__body">
      <div class="progress">
        <button
          v-for="(step, index) in steps"
          :key="index"
          :class="{active: currentStep === step.id, 'icon icon--check': step.id === steps.length}"
          class="progress__btn"
          @click="handleThermometerProgress(step.id)"
          v-html="step.id === steps.length ? '' : `<span>${step.id}</span>`"
        />
      </div>

      <main
        id="stepper"
        :class="'stepper-' + currentStep"
        class="stepper"
      >
        <Transition :duration="stepTransitionDuration" mode="out-in">
          <div v-show="currentStep === 1" class="stepper__step">
            <h4 class="stepper__title">Für wen wird eine Pflegeberatung benötigt?</h4>
            <div
              v-tooltip="{html: true, content: tooltipContent.s1}"
              class="icon icon--help"
            />
            <InputChoice
              v-model="appData.s1.value"
              :value="appData.s1.value"
              :options="appData.s1.options"
            />
          </div>
        </Transition>

        <Transition :duration="stepTransitionDuration" mode="out-in">
          <div v-show="currentStep === 2" class="stepper__step step2">
            <h4 class="stepper__title">In welcher Region wird eine Pflegeberatung benötigt?</h4>
            <div
              v-tooltip="{html: true, content: tooltipContent.s2}"
              class="icon icon--help"
            />
            <div class="zip-autocomplete">
              <Multiselect
                v-model="appData.s2.value"
                id="zip-autocomplete"
                name="zip-autocomplete"
                :class="{focused: acListFocused}"
                input-type="text"
                autocomplete="off"
                placeholder="Hier Postleitzahl eingeben"
                :searchable="true"
                :options="appData.s2.options"
                no-options-text="Bitte geben Sie eine Postleitzahl ein"
                :resolve-on-load="false"
                :filterResults="false"
                track-by="value.id"
                :object="true"
                @search-change="handleACChange"
                @select="handleACSelect"
                @close="handleACClose"
                @clear="handleACClear"
              >
                <template v-slot:singlelabel="{ value }">
                  <div class="multiselect-single-label">
                    <span> {{ value.value.zip }} </span>
                  </div>
                </template>

                <template v-slot:option="{ option }">
                  <span><strong> {{ option.value?.city }} </strong></span>
                  <span> {{ option.value?.zip }} </span>
                </template>

              </Multiselect>

              <span
                v-if="appData.s2.zipCodeErrorVisible"
                class="icon icon--sort-up help is-danger">Zu Ihrer Postleitzahl gibt es mehr als einen Ort. Bitte wählen Sie einen Ort aus der Liste aus.
              </span>

            </div>
          </div>
        </Transition>

        <Transition :duration="stepTransitionDuration" mode="out-in">
          <div v-show="currentStep === 3" class="stepper__step">
            <h4 class="stepper__title">Liegt ein Pflegegrad vor?</h4>
            <div
              v-tooltip="{html: true, content: tooltipContent.s3}"
              class="icon icon--help">
            </div>
            <InputChoice
              v-model="appData.s3.value"
              :value="appData.s3.value"
              :options="appData.s3.options"
            />

            <div class="custom-input">
              <h4 class="stepper__title">Bei welcher Krankenkasse ist die zu pflegende Person versichert?</h4>
              <input
                v-model="appData.s3.krankenkasse.name"
                type="text"
                name="krankenkasse"
                placeholder="Krankenkasse"
                maxlength="15"
                class="krankenasse-input">
            </div>

            <h4 class="stepper__title">Ist eine gesetzliche Betreuung mit Gesundheitsfürsorge vorhanden?</h4>
            <InputChoice
              v-model="appData.s3.value_2"
              :value="appData.s3.value_2"
              :options="appData.s3.options_2"
            />
            <div v-if="appData.s3.value === 'Nein'" class="care-degree-notification">
              <div v-if="appData.priceApi">
                Bitte beachten Sie, dass ohne vorhandenen Pflegegrad in Einzelfällen Kosten für eine Pflegeberatung in
                Höhe von {{ appData.price }}€ anfallen können.
              </div>
              <div v-else>
                Bitte beachten Sie, dass ohne vorhandenen Pflegegrad in Einzelfällen Kosten für eine Pflegeberatung
                anfallen können.
              </div>
            </div>
          </div>
        </Transition>

        <Transition :duration="stepTransitionDuration" mode="out-in">
          <div v-show="currentStep === 4" class="stepper__step step4">
            <h4 class="stepper__title">Bitte geben Sie hier Ihre Kontaktinformationen ein</h4>
            <div
              v-tooltip="{html: true, content: tooltipContent.s4}"
              class="icon icon--help"
            />
            <FormComponent
              ref="firstFormComponent"
              form-id="mailform"
              :app-theme-brand="app_theme_brand"
              @validation-updated="handleValidationErrors"
            />
            <div class="installationadresse-wrapper">
              <div class="stepper__input stepper__input-installationsadresse">
                <h6 class="sub-title">Installationsadresse</h6>
                <Toggle v-model="appData.installation_address_checkbox" class="toggle-blue" />
                <label class="checkbox-title switch-label"><h6>Die Installationsadresse entspricht der Adresse der
                  Kontaktinformationen</h6></label>
              </div>
              <div>
                <div v-if="!appData.installation_address_checkbox">
                  <FormComponent
                    ref="installationFormComponent"
                    form-type="installation_address_"
                    :app-theme-brand="app_theme_brand"
                    @validation-updated="handleValidationErrors"
                  />
                </div>
              </div>
            </div>

            <div v-if="appData.s3.value === 'Nein'" class="care-degree-notification">
              <div v-if="appData.priceApi">
                Bitte beachten Sie, dass ohne vorhandenen Pflegegrad in Einzelfällen Kosten für eine Pflegeberatung in
                Höhe von {{ appData.price }}€ anfallen können.
              </div>
              <div v-else>
                Bitte beachten Sie, dass ohne vorhandenen Pflegegrad in Einzelfällen Kosten für eine Pflegeberatung
                anfallen können.
              </div>
            </div>
            <div>
              <div v-if="appData.contact.meeting_times_api" class="stepper__input termin_select_checkbox">
                <DateTimePickerComponent
                  ref="dateTimePickerComponent"
                  :handle-iframe-height="handleIframeHeight"
                />
              </div>
            </div>
            <div class="stepper__input terms-and-conditions">
              <div class="checkbox-component">
                <input id="app-agree" v-model="agree" type="checkbox" name="Datenschutz" value="">
                <label for="app-agree">
                  <span class="input-box">
                    <svg viewBox="0 0 16 16" class="input-box-tick">
                      <path :class="{ 'no-stroke': !agree }" fill="none" d="M1.7,7.8l3.8,3.4l9-8.8"></path>
                    </svg>
                  </span> Ja, ich habe die <a href="https://www.johanniter.de/datenschutz/" target="_blank">Datenschutzerklärung</a>
                  zur Kenntnis genommen und bin mit der Verarbeitung meiner Daten im Rahmen dieser Anfrage einverstanden
                </label>
              </div>
            </div>
          </div>
        </Transition>

        <div v-if="currentStep === 5" style="text-align: center; margin-bottom: -40px;">
          <h4>Sie haben von uns eine Bestätigung per E-Mail bekommen. Wir bedanken uns für Ihre Anfrage und wünschen
            Ihnen einen schönen Tag.</h4>
        </div>

        <div v-if="currentStep !== 2"
             v-show="formErrorMessage"
             class="error-message-global">{{ formErrorMessage }}
        </div>
        <div v-if="currentStep === 2"
             v-show="formErrorMessage"
             class="error-message-zip">
          <p>Leider kann die Dienstleistung Ihrer Region nicht angeboten werden.</p>
          <p>Lassen Sie uns gemeinsam nach einer Lösung suchen. Kontaktieren Sie dafür gerne unsere kostenfreie
            Kundenservicehotline unter <span>+49 800 3233800</span>.</p>
        </div>
        <div class="nav">
          <button v-show="currentStep > 1 && currentStep <= 6"
                  ref="stepBackwards"
                  class="button button--backwards"
                  @click="handleStepProgress(currentStep - 1);">Zurück
          </button>
          <button v-show="currentStep >= 1 && currentStep < 4"
                  ref="stepForwards"
                  class="button button--forwards"
                  @click="handleStepProgress(currentStep + 1)">Weiter
          </button>

          <button v-show="currentStep == 4"
                  ref="stepForwards"
                  class="button button--forwards button--forwards-last"
                  @click="handleStepProgress(currentStep + 1)">Unverbindlich anfragen
          </button>
        </div>

      </main>
    </div>
  </div>
</template>


<style lang="scss">
div.heading {
  margin-top: 20px;
  text-align: center;
  // Fonts from the https://www.johanniter.de/dienste-leistungen/pflege-und-begleitung/hausnotruf/
  font-family: "MavenProBold", Arial, sans-serif;
  font-size: 2rem;
  line-height: 1.15;
  color: #000548;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  overflow-wrap: break-word;

  @media (max-width: 600px) {
    margin-top: 100px;
    font-size: 1.25rem;
  }
}

.step-wrapper {
  padding: 3rem;
}

.toggle-container .toggle {
  width: 35px;
}

.toggle-container .toggle-handle {
  width: 20px;
  height: 20px;
  top: auto;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.back a {
  text-decoration: none;
  color: #000548;
  font-size: 14px;
}

.terms-and-conditions {
  display: flex;
}

.terms-and-conditions #app-agree {
  display: none;
}

.terms-and-conditions label {
  font-size: 14px;
}

.checkbox-component .input-box {
  display: inline-block;
  border: 1px solid #000;
  border-radius: 14%;
  background: #fff;
  overflow: hidden;
  vertical-align: -5%;
  user-select: none;
}

.checkbox-component .input-box .no-stroke {
  stroke: none !important;
}

/* Tooltip width */
.v-popper__popper {
  max-width: 350px;
}

.stepper-2.stepper {
  .autocomplete-wrapper {
    input {
      min-width: 300px;
      text-align: center;
    }

    &.selected {
      input {
        box-shadow: 0 0 0 2px rgba(#b92525, 1);
      }
    }
  }
}
</style>
